import { render, staticRenderFns } from "./BoardPreview.vue?vue&type=template&id=5a1703d2&scoped=true&lang=pug&"
import script from "./BoardPreview.vue?vue&type=script&lang=js&"
export * from "./BoardPreview.vue?vue&type=script&lang=js&"
import style0 from "./BoardPreview.vue?vue&type=style&index=0&id=5a1703d2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1703d2",
  null
  
)

export default component.exports